// Older checkout URLs contained a trailing slash in the configured portal
// origin. Repair their path before BrowserRouter reads it, retaining ref_payco.
export function normalizePortalPath(location, history) {
  const path = location.pathname.replace(/\/{2,}/g, "/");
  if (path !== location.pathname) {
    history.replaceState(history.state, "", path + location.search + location.hash);
  }
}
